// import React from 'react'
// import Link from 'next/link'

// interface TocItem {
//   value: string
//   url: string
//   depth: number
//   children?: TocItem[]
// }

// interface CustomTOCProps {
//   toc: TocItem[]
// }

// const CustomTOC: React.FC<CustomTOCProps> = ({ toc }) => {
//   const renderTocItems = (items: TocItem[]) => {
//     return (
//       <ul className="space-y-2 text-primary-500">
//         {items.map((item, index) => (
//           <li key={index} className="hover:text-heading-400">
//             <Link href={item.url.replace(/-\d+$/, '')}>
//               {item.value}
//             </Link>
//             {item.children && item.children.length > 0 && (
//               <ul className="ml-4 mt-2 space-y-2">
//                 {renderTocItems(item.children)}
//               </ul>
//             )}
//           </li>
//         ))}
//       </ul>
//     )
//   }

//   return (
//     <nav className="toc">
//       <h2 className="text-xl font-bold text-heading-400 mb-4">Tabla de Contenidos</h2>
//       {renderTocItems(toc)}
//     </nav>
//   )
// }

// export default CustomTOC

'use client'

import React from 'react'
import TOCInline from 'pliny/ui/TOCInline.js'
import type { Toc, TocItem as OriginalTocItem } from 'pliny/mdx-plugins/remark-toc-headings.js'
interface TocBodyProps {
  toc: Toc
}

interface TocItem extends OriginalTocItem {
  children?: TocItem[]
}

const filterToc = (toc: TocItem[]): TocItem[] => {
  return toc.map((item) => {
    const modifiedValue = item.url.replace(/-\d+$/, '')
   

    return {
      ...item,
      url: modifiedValue,
    }
  })
}



// const filterToc = (toc: TocItem[]): TocItem[] => {
//   return toc.map((item) => item)  // This will keep the original URLs
// }

const CustomTOC = ({ toc }: TocBodyProps) => {



  const filteredToc = filterToc(toc as TocItem[])

  const renderFallbackTOC = () => (
    <ul>
      {toc.map((item, index) => (
        <li key={index} style={{ marginLeft: `${(item.depth - 1) * 20}px` }}>
          <a href={item.url}>{item.value}</a>
        </li>
      ))}
    </ul>
  )

  return (
      <TOCInline
      toc={filteredToc}
      ulClassName="space-y-2 overflow-y-auto my-auto text-primary-500"
      liClassName="hover:text-heading-400"
      />
  )
}

export default CustomTOC